import { MAX_SHIPPING_LABEL_QUANTITY } from '~/constants';

/**
 * [운송장 관리] 추가 운송장 수량 입력값에서 숫자 외 문자를 제거한다.
 */
export const sanitizeShippingLabelQuantity = (value: string): string => value.replace(/[^0-9]/g, '');

/**
 * [운송장 관리] 입력 수량이 최대 수량(30)을 초과하는지 여부.
 * 초과 시 인풋 에러 상태·안내문구 노출에 사용한다.
 */
export const isShippingLabelQuantityExceeded = (value: string): boolean => {
  if (value === '') return false;
  return Number(value) > MAX_SHIPPING_LABEL_QUANTITY;
};

/**
 * [운송장 관리] [확인] 버튼 활성화 여부 — 숫자 1 이상이면 활성화(정책).
 * 30 초과여도 활성화되며, 실제 진행 여부는 canCreateShippingLabelQuantity로 판단한다.
 */
export const canConfirmShippingLabelQuantity = (value: string): boolean => {
  if (value === '') return false;
  return Number(value) >= 1;
};

/**
 * [운송장 관리] 실제 생성 진행 가능 여부 — 1~30 유효 수량일 때만 true.
 */
export const canCreateShippingLabelQuantity = (value: string): boolean => {
  if (value === '') return false;
  const count = Number(value);
  return count >= 1 && count <= MAX_SHIPPING_LABEL_QUANTITY;
};
